import {createApp} from 'vue'
import OrdreOverview from './OrdreOverview'

const el = '.kb-component--ordre-overview'

export default function(Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((OrdreOverviewDOM) => {
            const props = {
                orders: JSON.parse(OrdreOverviewDOM.dataset.orders),
            }
            const component = createApp(OrdreOverview, props).use(Store)
            component.mount(OrdreOverviewDOM)
        })
    }
}